import { useState } from "react";
import { Input, Button, Text, Loading } from "@nextui-org/react";
import { TbPlus, TbMinus } from "react-icons/tb";
import { motion } from "framer-motion";
import useInput from "../../hooks/useInput";
import { useSelector, useDispatch } from "react-redux";
import { invtryActions } from "../../redux/inventorySlice";

const MotionButton = motion(Button);
const btnAnim = {
  whileTap: { scale: 0.9 },
};

const QuantityInput = (props) => {
  let alt = props.alt,
    sunil = props.sunil,
    threeH = props.threeH;

  const token = useSelector((state) => state.invtry.token);
  const dispatch = useDispatch();
  const {
    inputValue: numValue,
    error: numError,
    isValid: numValid,
    inputHandler: numHandler,
    blurHandler: numBlur,
    clearInput: clearNum,
  } = useInput((value) => value != "" || value != 0);

  const [loading, setLoading] = useState(false);
  const storedIphones = useSelector((state) =>
    threeH
      ? state.invtry.storedIphones4
      : sunil
        ? state.invtry.storedIphones3
        : alt
          ? state.invtry.storedIphones2
          : state.invtry.storedIphones,
  );
  const storedIpods = useSelector((state) =>
    threeH
      ? state.invtry.storedIpods4
      : sunil
        ? state.invtry.storedIpods3
        : alt
          ? state.invtry.storedIpods2
          : state.invtry.storedIpods,
  );
  const storedWatches = useSelector((state) =>
    threeH
      ? state.invtry.storedWatches4
      : sunil
        ? state.invtry.storedWatches3
        : alt
          ? state.invtry.storedWatches2
          : state.invtry.storedWatches,
  );

  const addHandler = () => {
    if (numValid) {
      setLoading(true);
      fetch("https://stockmanager-api.vercel.app/add-stock", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          variantId: props.variant._id,
          id: props.id,
          name: props.name,
          pid: props.pid,
          desc:
            props.variant.storage ||
            props.variant.size + " " + props.variant.type,
          add: numValue,
          category: props.category,
          alt,
          sunil,
          threeH,
        }),
      })
        .then((res) => {
          if (!res.ok) {
            console.log("Error");
          }
          return res.json();
        })
        .then((data) => {
          if (props.category === "iPhones") {
            console.log(data);
            props.update(data.response);
            let copyProds = [...storedIphones],
              findIndex;
            findIndex = copyProds.findIndex((doc) => {
              return doc._id.toString() === data.response._id.toString();
            });
            if (findIndex >= 0) {
              copyProds[findIndex] = data.response;
              dispatch(
                threeH
                  ? invtryActions.setStoredIphones4(copyProds)
                  : sunil
                    ? invtryActions.setStoredIphones3(copyProds)
                    : alt
                      ? invtryActions.setStoredIphones2(copyProds)
                      : invtryActions.setStoredIphones(copyProds),
              );
            }
          } else if (props.category === "AirPods") {
            props.update(data.response);
            let copyProds = [...storedIpods],
              findIndex;
            findIndex = copyProds.findIndex((doc) => {
              return doc._id.toString() === data.response._id.toString();
            });
            console.log(findIndex);
            if (findIndex >= 0) {
              copyProds[findIndex] = data.response;
              dispatch(
                threeH
                  ? invtryActions.setStoredIpods4(copyProds)
                  : sunil
                    ? invtryActions.setStoredIpods3(copyProds)
                    : alt
                      ? invtryActions.setStoredIpods2(copyProds)
                      : invtryActions.setStoredIpods(copyProds),
              );
            }
          } else if (props.category === "Watches") {
            props.update(data.response);
            let copyProds = [...storedWatches],
              findIndex;
            findIndex = copyProds.findIndex((doc) => {
              return doc._id.toString() === data.response._id.toString();
            });
            if (findIndex >= 0) {
              copyProds[findIndex] = data.response;
              dispatch(
                threeH
                  ? invtryActions.setStoredWatches4(copyProds)
                  : sunil
                    ? invtryActions.setStoredWatches3(copyProds)
                    : alt
                      ? invtryActions.setStoredWatches2(copyProds)
                      : invtryActions.setStoredWatches(copyProds),
              );
            }
          }

          clearNum();
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const subHandler = () => {
    if (numValid) {
      setLoading(true);
      fetch("https://stockmanager-api.vercel.app/sub-stock", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          variantId: props.variant._id,
          id: props.id,
          name: props.name,
          pid: props.pid,
          desc:
            props.variant.storage ||
            props.variant.size + " " + props.variant.type,
          sub: -Number(numValue),
          category: props.category,
          alt,
          sunil,
          threeH,
        }),
      })
        .then((res) => {
          if (!res.ok) {
            console.log("Error");
          }
          return res.json();
        })
        .then((data) => {
          if (props.category === "iPhones") {
            props.update(data.response);
            let copyProds = [...storedIphones],
              findIndex;
            findIndex = copyProds.findIndex((doc) => {
              return doc._id.toString() === data.response._id.toString();
            });
            if (findIndex >= 0) {
              copyProds[findIndex] = data.response;
              dispatch(
                threeH
                  ? invtryActions.setStoredIphones4(copyProds)
                  : sunil
                    ? invtryActions.setStoredIphones3(copyProds)
                    : alt
                      ? invtryActions.setStoredIphones2(copyProds)
                      : invtryActions.setStoredIphones(copyProds),
              );
            }
          } else if (props.category === "AirPods") {
            props.update(data.response);
            let copyProds = [...storedIpods],
              findIndex;
            findIndex = copyProds.findIndex((doc) => {
              return doc._id.toString() === data.response._id.toString();
            });
            if (findIndex >= 0) {
              copyProds[findIndex] = data.response;
              dispatch(
                threeH
                  ? invtryActions.setStoredIpods4(copyProds)
                  : sunil
                    ? invtryActions.setStoredIpods3(copyProds)
                    : alt
                      ? invtryActions.setStoredIpods2(copyProds)
                      : invtryActions.setStoredIpods(copyProds),
              );
            }
          } else if (props.category === "Watches") {
            props.update(data.response);
            let copyProds = [...storedWatches],
              findIndex;
            findIndex = copyProds.findIndex((doc) => {
              return doc._id.toString() === data.response._id.toString();
            });
            if (findIndex >= 0) {
              copyProds[findIndex] = data.response;
              dispatch(
                threeH
                  ? invtryActions.setStoredWatches4(copyProds)
                  : sunil
                    ? invtryActions.setStoredWatches3(copyProds)
                    : alt
                      ? invtryActions.setStoredWatches2(copyProds)
                      : invtryActions.setStoredWatches(copyProds),
              );
            }
          }
          clearNum();
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  return (
    <div className="qtyInputLine">
      <Text css={{ w: "20%", wordWrap: "break-word" }} size="15px">
        {props.variant.storage || props.variant.size + " " + props.variant.type}
      </Text>

      <div className="qty">
        <Text color="$blue800" size="15px" className="qtyProd" b>
          {props.variant.quantity}
        </Text>
        |
        <Input
          type="number"
          className="qtyInput"
          size="sm"
          css={{ w: "70%" }}
          aria-label="Quantity"
          placeholder="Number..."
          onChange={numHandler}
          value={numValue}
        />
      </div>

      <MotionButton
        icon={loading ? <Loading type="spinner" /> : <TbMinus />}
        color="error"
        auto
        size="sm"
        flat
        onClick={subHandler}
        {...btnAnim}
      />
      <MotionButton
        icon={loading ? <Loading type="spinner" /> : <TbPlus />}
        color="success"
        auto
        size="sm"
        flat
        onClick={addHandler}
        {...btnAnim}
      />
    </div>
  );
};

export default QuantityInput;
